import React, { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
import { Dropdown, Menu } from 'antd'
import classnames from 'classnames'
import zy from 'image/logos/zy.png'
import mn from 'image/logos/mn.png'
import cb from 'image/logos/cb.png'
import zk from 'image/logos/zk.png'
import dy from 'image/logos/dy.png'
import xhs from 'image/logos/xhs.png'
import plusFd from 'image/logos/plus-fd-logo.png'
import logo from 'image/logo.svg'
import { Icon } from 'meinian-package/src/component'
import util from 'meinian-package/src/utils/util'
import { hasAuth } from 'meinian-package/src/utils/auth'
import styles from './index.module.less'

const ROUTE_TO_OTHER = [
  {
    icon: zy,
    label: '知衣',
    subText: '电商大数据爆款挖掘与趋势分析',
    link: '/home',
  },
  {
    icon: zk,
    label: '知款',
    subText: '快速发现时尚趋势灵感',
    link: hasAuth('dl_ins') ? '/df' : '/afflatus',
  },
  {
    icon: dy,
    label: '抖衣',
    subText: '优选抖音鞋服爆款',
    link: '/douyin',
  },
  {
    icon: cb,
    label: '海外探款',
    subText: '高效挖掘海外服饰趋势',
    link: '/cross-border/monitoring/site/new-goods',
  },
  {
    icon: xhs,
    label: '知小红',
    subText: '方便快速寻找小红书达人种草',
    link: '/xhs',
  },
  {
    icon: mn,
    label: '美念',
    subText: '简单好用的服饰设计协作平台',
    link: '/meinian/home',
  },
  {
    icon: plusFd,
    label: 'Fashion Diffusion+',
    subText: 'AI 加持的服饰设计全流程智能工具',
    link: '/plus-fd',
  },
  {
    icon: 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/zy-image/%E8%B6%8B%E5%8A%BF%E6%8A%A5%E5%91%8Aicon%402x%202.png',
    label: '趋势报告',
    subText: '电商行情洞察与流行趋势分析',
    link: '/report',
  },
  {
    icon: 'https://cdn.zhiyitech.cn/material/b06ac94e90415260bff42e78d8cd0a8e',
    label: '知小布',
    subText: '面料商都在用的精准获客新方式',
    link: '/fabric-cube',
    isNew: true,
  },
  {
    icon: 'https://cdn.zhiyitech.cn/material/66305aae6a764ba59efe0aa946224ba6',
    label: '面料中心',
    subText: '高效找面料与洞察面料趋势',
    link: '/fabric-cube/center',
    isNew: true,
  },
  {
    icon: 'https://cdn.zhiyitech.cn/material/c5abb222e462c85ad78d1bf0eec53e3f',
    label: '知小衣',
    subText: '服装设计师的AI助理',
    link: '/chat-zxy',
    isNew: true,
  },
]

export default ({ mainHeader = true, style, overlayClassName, overlayStyle }) => {
  // const history = useNavigate()
  const [menuVisible, setMenuVisible] = useState(false)
  // 其他业务线导航

  const onLink = (label) => {
    util.track('mn-header-link', {
      module1: '顶部导航',
      module2: '产品切换',
      module3: label,
    })
  }

  const menu = (
    <Menu className={styles['nav-switcher-submenu']}>
      {ROUTE_TO_OTHER.map((route) => {
        return (
          <Menu.Item key={route.label}>
            <a href={route.link} target="_blank" className="clickable" rel="noreferrer" onClick={() => onLink(route.label)}>
              <div className="nav-switcher-submenu-item">
                <img src={route.icon} alt="" />
                <div className="nav-switcher-submenu-item-text">
                  <div>
                    {route.label}
                    {route.isNew && <span className="nav-switcher-submenu-item-new">NEW</span>}
                  </div>
                  <div>{route.subText}</div>
                </div>
              </div>
            </a>
          </Menu.Item>
        )
      })}
    </Menu>
  )

  return (
    <div className={styles.switcher} style={style}>
      <Dropdown overlay={menu} trigger={['hover']} onVisibleChange={(vis) => setMenuVisible(vis)}>
        <div className="nav-switcher-btn" style={overlayStyle}>
          <Icon type="m-qiehuanqi" className={classnames('nav-switcher-btn-icon', { active: menuVisible }, overlayClassName)} />
        </div>
      </Dropdown>
      {mainHeader && (
        <>
          <div className="logo-line" />
          <img src={logo} className={styles.logo} onClick={() => (location.href = '/meinian/home/coll')} />
        </>
      )}
    </div>
  )
}
